import { render, staticRenderFns } from "./keynote-dimension.vue?vue&type=template&id=9e3aadba&scoped=true&"
import script from "./keynote-dimension.vue?vue&type=script&lang=js&"
export * from "./keynote-dimension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3aadba",
  null
  
)

export default component.exports